import React, { useEffect } from 'react'
import useAppDispatch from './useAppDispatch'
import useReduxData from './useReduxData';
import useAllCharges from './AllCharge';
import { couponDetails } from '../constant/constant';
import { SETISDISCOUNTAPPLY, SETTOTALCOUPONTOTAL } from '../redux/features/CartData';
const useDiscountApply = () => {
    const dispatch = useAppDispatch()
    const [taxes] = useAllCharges()
    const {
        cartData: { discountCouponTotal, isDiscountApply },
    } = useReduxData();

    useEffect(() => {
        if (isDiscountApply || (isDiscountApply == false && discountCouponTotal > 0)) {
            setDiscount()
        }
    }, [isDiscountApply, taxes.sub_total, taxes.tax_amount])

    const setDiscount = () => {
        let discountValue = 0;
        if (isDiscountApply) {
            let totalAmount = (taxes.sub_total || 0) + (taxes.tax_amount || 0) //one is items ubs total and second is tax total
            discountValue = (totalAmount * couponDetails.value) / 100;
        }

        dispatch(SETTOTALCOUPONTOTAL(discountValue));

    }

    const setIsDiscountApply = () => {
        dispatch(SETISDISCOUNTAPPLY(!isDiscountApply));
        // setDiscount(!isDiscountApply)
    }
    return { setIsDiscountApply }
}

export default useDiscountApply